// import {playMode} from '../common/js/config'
// import {loadSearch, loadPlay, loadFavorite} from '../common/js/cache'
// // 原始数据
const state = {
  courseId: '',
  userId: '',
  studyExperience: [],
  workExperience: [],
  user: null,
  // 保存课程分类里课程的内容
  recommendCourse: {},
  currentData: '',
  searchMark: '1',
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js